"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOperationEnum = void 0;
var FilterOperationEnum;
(function (FilterOperationEnum) {
    FilterOperationEnum["CONTAINS"] = "contains";
    FilterOperationEnum["EQUALS"] = "equals";
    FilterOperationEnum["STARTSWITH"] = "startsWith";
    FilterOperationEnum["ENDSWITH"] = "endsWith";
    FilterOperationEnum["MATCHES"] = "matches";
})(FilterOperationEnum = exports.FilterOperationEnum || (exports.FilterOperationEnum = {}));
